import React from 'react';
import './App.css';
import twitter from './socials/twitter.png'
import youtube from './socials/youtube.png'
import lnk from './socials/lnk.png'
import Github from './socials/Octocat.png'


export default function Social({mailMe}) {
    return(
        <div>
            <h1>{mailMe}</h1>
                        <div class="social-container2">
                        <a href="https://twitter.com/ttf123457">
                        <img src={twitter} alt="" width="100px" />
                        </a>
                
                        
                        <a href='https://www.youtube.com/channel/UC6sW-ySnK3c72_9vJAOdQow'><img src={youtube} alt="img" width="100px" />
                        </a>
                        <a href="https://github.com/samsalgado"><img src={Github} alt="" width="100px" />
                        </a>
                        <a href="https://www.linkedin.com/in/blockchainmerlin/"><img src={lnk} alt="" width="100px"/></a>
                         </div> 
            
        </div>
    )
}